// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
export function createCSVContent({ data }: { readonly data: readonly string[][] }) {
  return data.map((row) => row.join(',')).join('\n');
}
// TODO: look at potential issues with this function
// https://chat.openai.com/c/d7c6de22-8412-4da7-9274-89c5a4f7f497
export function downloadCSV({ content, title }: { readonly content: string; readonly title: string }) {
  const blob = new Blob([content], { type: 'text/csv' });

  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `${title}.csv`;

  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
}
